import { styled } from '@mui/material'
import { OutLimitAgeChilds } from "../../../../containers/common/acceptAgeLimit"
import { GetFacilityDto } from "../../../../dataAccess/webApi/dto/facilitiesDto"
import { translate } from "../../../../i18n"
import { formatAcceptAge, formatAcceptAgeRange } from "../../../../utils/itemFormatUtil"
import { NullPropsToUndefinedType } from "../../../../utils/typeUtil"
import { ButtonOutlinedS } from "../buttons/buttonOutlinedS"
import { Dialog } from "../dialog"

const AgeNote = styled('div')({
  whiteSpace: 'pre-wrap',
})

interface NotAcceptAgeDialogProps {
    isOpen: boolean
    closeButtonText: string
    close: () => void
    facility: NullPropsToUndefinedType<GetFacilityDto>
    outLimitAgeChilds: OutLimitAgeChilds[]
}

export const NotAcceptAgeDialog = (props: NotAcceptAgeDialogProps) => {
    const acceptAgeFrom = formatAcceptAge(
        props.facility.acceptStartAge, 
        props.facility.acceptStartMonth, 
        props.facility.acceptStartDay, 
        props.facility.acceptStartAgeGradeFlag)
    const acceptAgeTo = formatAcceptAge(
        props.facility.acceptEndAge, 
        props.facility.acceptEndMonth, 
        props.facility.acceptEndDay, 
        props.facility.acceptEndAgeGradeFlag)

    const ageLimitDialogContent = (
        <>
            <div>{acceptAgeFrom && acceptAgeTo && formatAcceptAgeRange(acceptAgeFrom, acceptAgeTo)}</div>
            <br />
            {props.outLimitAgeChilds.map((child: OutLimitAgeChilds) => {
                if (child.isUnder) {
                    return (<>
                        <div>{child.name}さまは受け入れ年齢の{acceptAgeFrom}に達する{props.facility.interviewBeforeDay}日前以降に申込を行ってください。</div>
                        <br />
                    </>)
                } else if (child.isOver) {
                    return (<>
                        <div>{child.name}さまは受け入れ年齢の{acceptAgeTo}を超えているため、申込することはできません。</div>
                        <br />
                    </>)
                }
            })}
            <AgeNote>{props.facility.ageNote}</AgeNote>
        </>
    )

    return <Dialog
        isOpen={props.isOpen}
        onClose={props.close}
        buttons={
            <ButtonOutlinedS onClick={props.close}>{translate('system.button.back')}</ButtonOutlinedS>
        }
        maxWidth={'xs'}
        fullWidth
    >
        {ageLimitDialogContent}
    </Dialog>
}